import styled from "styled-components";
import { useTranslation } from "react-i18next";
import colors from "@styling/colors";

const Change = styled.span<{ $direction: number }>`
  font-weight: 600;
  color: ${({ $direction }) =>
    $direction > 0
      ? colors.successText
      : $direction < 0
        ? colors.dangerText
        : colors.textMuted};
`;

export type StatChange = {
  value: number;
  label: string;
};

interface StatChangeFooterProps {
  change: StatChange | null;
  comparisonDateLabel: string;
}

export const StatChangeFooter = ({
  change,
  comparisonDateLabel,
}: StatChangeFooterProps) => {
  const { t } = useTranslation();

  if (!change) {
    return <>{t("adminMrrStats.noComparison", { date: comparisonDateLabel })}</>;
  }

  return (
    <>
      <Change $direction={change.value}>{change.label}</Change>{" "}
      {t("adminMrrStats.comparedTo", { date: comparisonDateLabel })}
    </>
  );
};
